<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_331_10947)">
<path d="M17.8332 9.5H14.4998V4.5H9.49984V9.5H6.1665L11.9998 15.3333L17.8332 9.5ZM6.1665 17V18.6667H17.8332V17H6.1665Z" fill="#93182F"/>
</g>
<defs>
<clipPath id="clip0_331_10947">
<rect width="20" height="20" fill="white" transform="translate(2 2)"/>
</clipPath>
</defs>
</svg>
